export default "__VITE_ASSET__BcYvB6WG__"